import React from 'react';

interface CriticalIllnessIconProps {
  className?: string;
  size?: number;
}

export const CriticalIllnessIcon: React.FC<CriticalIllnessIconProps> = ({ 
  className = '', 
  size = 150 
}) => {
  return (
    <svg 
      id="Layer_1" 
      xmlns="http://www.w3.org/2000/svg" 
      version="1.1" 
      viewBox="0 0 150 150"
      width={size}
      height={size}
      className={className}
    >
      <defs>
        <style>
          {`.st0 {
            fill: none;
            stroke: #e3e3e3;
            stroke-linecap: round;
            stroke-linejoin: round;
            stroke-width: 9px;
          }`}
        </style>
      </defs>
      <polyline className="st0" points="39.5 119.67 39.5 110.94 121.32 110.94 121.32 119.67"/>
      <circle className="st0" cx="39.5" cy="127.08" r="3.83"/>
      <circle className="st0" cx="121.32" cy="127.08" r="3.83"/>
      <path className="st0" d="M114.73,72.52h-58.06l-29.06-29.06-6,6c-2.74,2.74-2.74,7.19,0,9.93l8.39,8.39"/>
      <path className="st0" d="M39.33,82.33H7.69v6.65c0,3.61,2.92,6.53,6.53,6.53h121.58c3.61,0,6.53-2.92,6.53-6.53v-9.92c0-3.61-2.92-6.53-6.53-6.53h-6.2"/>
      <line className="st0" x1="56.67" y1="95.51" x2="56.67" y2="108.75"/>
      <line className="st0" x1="105.41" y1="95.51" x2="105.41" y2="108.75"/>
      <line className="st0" x1="64.46" y1="23.34" x2="64.46" y2="55.97"/>
      <polyline className="st0" points="49.41 26.93 49.41 19.1 80.41 19.1 80.41 26.93"/>
    </svg>
  );
};
